import React from "react";
import Styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div>
      <div className="container bg-dark text-white py-2 mt-3">
        <div className={Styles.contactInfo_style}>
          <span>Email: mediappointcare@gmail.com</span>
          <span>WhatsApp/Phone: 01919862754</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
